import axios from "axios";

const {
  REACT_APP_CAC_URL,
  REACT_APP_WALLET_URL,
  REACT_APP_CH_URL,
} = process.env;

async function getCacUserProfile(cardNumber: string) {
  try {
    const res = await axios.get(
      `${REACT_APP_CAC_URL}/cards/${cardNumber}/user-profile?cardNumber=${cardNumber}`
    );
    return res.data;
  } catch (err) {
    console.info("Error fetching CAC user profile:", err);
  }
}

/*
async function getCurrentRatesFares(date: Date | string) {
  const entityId: any = localStorage.getItem("entityId");
  const res = await axios.get(
    `${REACT_APP_SITFARES_URL}/fares/current-fare?entityId=${entityId}&date=${date}`
  );
  return res.data;
}

async function getReferenceFares(id: number) {
  const res = await axios.get(`${REACT_APP_SITFARES_URL}/referenceFares/${id}`);
  return res.data;
}

async function getBonificationRate() {
  const entityId: any = localStorage.getItem("entityId");
  const res = await axios.get(
    `${REACT_APP_SITFARES_URL}/bonuses/resident?entityId=${entityId}`
  );
  return res.data;
}
*/

async function getMyWalletInfo() {
  try {
    const res = await axios.get(`${REACT_APP_WALLET_URL}/my-wallet`);
    return res.data;
  } catch (err) {
    console.info("Error fetching wallet info:", err);
  }
}

async function getNextTravel(jumps: number, points: number, profileId: number) {
  try {
    const res = await axios.get(
      `${REACT_APP_CH_URL}/calculator-by-profile?jumps=${jumps}&points=${points}&profileId=${profileId}&date=${new Date()
        .toISOString()
        .slice(0, 16)}`
    );
    return res.data;
  } catch (err) {
    console.info("Error calculating next travel:", err);
  }
}

async function getBonusesResident(profileId: number) {
  try {
    const res = await axios.get(
      `${REACT_APP_CH_URL}/points-by-profile?profileId=${profileId}`
    );
    return res.data;
  } catch (err) {
    console.info("Error fetching bonuses resident:", err);
  }
}

export const NextTravelApi = {
  getCacUserProfile,
  getMyWalletInfo,
  getNextTravel,
  getBonusesResident,
};
